var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _vm._m(1),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-6" }, [
        _c("h4", [_vm._v("Habilitar PayPal")]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group mt-2" }, [
          _c("label", [_vm._v("E-mail")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.paypalEmail,
                expression: "paypalEmail"
              }
            ],
            staticClass: "form-control",
            attrs: { type: "text" },
            domProps: { value: _vm.paypalEmail },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.paypalEmail = $event.target.value
              }
            }
          })
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _vm._m(2),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-6 plus-form" }, [
        _c(
          "a",
          {
            attrs: {
              target: "_blank",
              href:
                "https://s3-sa-east-1.amazonaws.com/new.click2giv.com/paypal-credentials.pdf"
            }
          },
          [_vm._v("Clique aqui")]
        ),
        _vm._v(" para acessar o passo a passo para gerar credenciais de Api."),
        _c("br"),
        _c("br"),
        _vm._v(" "),
        _c("span", [_vm._v("Credenciais")]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group mt-2" }, [
          _c("label", [_vm._v("Client Id:")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.paypalClientId,
                expression: "paypalClientId"
              }
            ],
            staticClass: "form-control",
            attrs: { type: "text" },
            domProps: { value: _vm.paypalClientId },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.paypalClientId = $event.target.value
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group mt-2" }, [
          _c("label", [_vm._v("Secret:")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.paypalSecret,
                expression: "paypalSecret"
              }
            ],
            staticClass: "form-control",
            attrs: { type: "text" },
            domProps: { value: _vm.paypalSecret },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.paypalSecret = $event.target.value
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Para utilizar o Checkout Transparente é preciso ter o pagamento recorrente habilitado também."
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-4" }, [
        _c(
          "button",
          {
            staticClass: "btn",
            on: {
              click: function($event) {
                $event.stopPropagation()
                $event.preventDefault()
                return _vm.save()
              }
            }
          },
          [_vm._v("Salvar Alterações")]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-8" }, [
        _vm.showMsg
          ? _c(
              "div",
              {
                staticClass: "alert alert-danger alert-dismissible fade show",
                attrs: { role: "alert" }
              },
              [
                _vm._v("\n        " + _vm._s(_vm.msg) + "\n        "),
                _c(
                  "button",
                  {
                    staticClass: "close",
                    attrs: {
                      type: "button",
                      "data-dismiss": "alert",
                      "aria-label": "Fechar"
                    },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        $event.preventDefault()
                        return _vm.hideMessage()
                      }
                    }
                  },
                  [
                    _c("span", { attrs: { "aria-hidden": "true" } }, [
                      _vm._v("×")
                    ])
                  ]
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.showSuccessMsg
          ? _c(
              "div",
              {
                staticClass: "alert alert-success alert-dismissible fade show",
                attrs: { role: "alert" }
              },
              [
                _vm._v("\n        " + _vm._s(_vm.successMsg) + "\n        "),
                _c(
                  "button",
                  {
                    staticClass: "close",
                    attrs: {
                      type: "button",
                      "data-dismiss": "alert",
                      "aria-label": "Fechar"
                    },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        $event.preventDefault()
                        return _vm.hideMessage()
                      }
                    }
                  },
                  [
                    _c("span", { attrs: { "aria-hidden": "true" } }, [
                      _vm._v("×")
                    ])
                  ]
                )
              ]
            )
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c("h4", [_vm._v("Meios de arrecadar")]),
        _vm._v(" "),
        _c("span", [
          _vm._v(
            "Receba doações com simplicidade e segurança utilizando o Paypal."
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6" }, [
      _vm._v(
        "\n      Utilize o PayPal para pagamentos recorrentes, aceitando cartões de crédito e débito do mundo inteiro."
      ),
      _c("br"),
      _c("br"),
      _vm._v(" "),
      _c(
        "a",
        {
          attrs: {
            href: "https://www.paypal.com/br/webapps/mpp/account-selection",
            target: "_blank"
          }
        },
        [_vm._v("Crie uma conta no PayPal")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6 instructions" }, [
      _c("b", [
        _vm._v(
          "Você pode habilitar também o pagamento com cartões de crédito através do Checkout Transparente do PayPal."
        )
      ]),
      _c("br"),
      _vm._v(" "),
      _c("span", [_vm._v("Basta seguir o passo a passo abaixo")]),
      _vm._v(" "),
      _c("div", { staticClass: "step" }, [
        _c("h3", [_vm._v("1")]),
        _vm._v(" "),
        _c("span", [
          _vm._v(
            "Entre em contato com a nossa central de atendimento através do 0800 047 4482"
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "step" }, [
        _c("h3", [_vm._v("2")]),
        _vm._v(" "),
        _c("span", [
          _vm._v(
            "Solicite a liberação do PayPal Plus na conta mediante a aprovação do produto."
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "step" }, [
        _c("h3", [_vm._v("3")]),
        _vm._v(" "),
        _c("span", [
          _vm._v(
            "Retorne para a Click2Giv após receber a confirmação da aprovação para configurar o produto, conforme o passo a passo fornecido pela Click2Giv."
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6fb93dbc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fb93dbc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/manage-project/Other.vue
// module id = null
// module chunks = 